import React from 'react';
import {rowColors, stickedLeft} from "./styling/participation";
import InputsTableParticipation from "./InputsTableParticipation";


// wyswietla tabele z instrumentami i muzykami i przekazuje funkcje do generowania i wyswietlania inputow
const InstrumentsMusiciansTableBody = (
    {t, users, projectList, ChangeDBHandler, dispatch, handleCopyEmail, isInstrumentVisible, hideEmpty, getStickyLeft, visibleColumns}
) => {
    const getRequiredCount = (instrument, projectId) => {
        const project = projectList.find(p => p.id === projectId);
        const entry = project?.totals?.find(t => t.name === instrument);
        return entry?.required_count || 0;
    };

    const getReportedCount = (instrument, projectId) => {
        const users_data = users.find(instr => instr[0] === instrument);
        if (!users_data) return 0;

        const summary_reported = users_data[1].reduce((acc, musician) => {
            const participation = musician.participation[projectId];
            if (participation && participation.status && participation.status.includes("1") && participation.status.includes("+"))  return acc += 1;
            return acc;
        }, 0)
        return summary_reported || 0
    };

    return users.map(([instrument, musicians], instIndex) => {
        if (!isInstrumentVisible(instrument)) return null;
        if (hideEmpty && (!musicians || musicians.length === 0)) return null;

        return (
            <React.Fragment key={instrument}>
                <tr>
                    <td colSpan={4 + projectList.length}></td>
                </tr>

                <tr style={{ fontWeight: 'bold' }}>
                    <td colSpan={4} style={{ ...stickedLeft, left: '0', backgroundColor: rowColors.instrumentLabel, whiteSpace: 'nowrap'}}>{instrument}</td>
                    <td colSpan={projectList.length} style={{ backgroundColor: rowColors.instrumentLabel}}></td>
                </tr>

                <InputsTableParticipation
                    musicians={musicians}
                    projectList={projectList}
                    getStickyLeft={getStickyLeft}
                    visibleColumns={visibleColumns}
                    instIndex={instIndex}
                    handleCopyEmail={handleCopyEmail}
                    dispatch={dispatch}
                    instrument={instrument}
                    ChangeDBHandler={ChangeDBHandler}
                    t={t}
                />

                <tr style={{fontWeight: 'bold', backgroundColor: rowColors.total}}>
                    <td colSpan={4} style={{...stickedLeft, left: '0', backgroundColor: rowColors.total}}>Total</td>
                    {projectList.map(project => (
                        <td key={`reported_${project.id}`} style={{ textAlign: 'center', backgroundColor: rowColors.total }}>
                            {getReportedCount(instrument, project.id)}
                        </td>
                    ))}
                </tr>
                <tr style={{ fontWeight: 'bold', backgroundColor: rowColors.required }}>
                    <td colSpan={4} style={{ ...stickedLeft, left: '0', backgroundColor: rowColors.required }}>Required</td>
                    {projectList.map(project => (
                        <td key={`required_${project.id}`} style={{ textAlign: 'center', backgroundColor: rowColors.required  }}>
                            {getRequiredCount(instrument, project.id)}
                        </td>
                    ))}
                </tr>
            </React.Fragment>
        );
    })
}

export default InstrumentsMusiciansTableBody

